import AuditDomainChip from "@/components/auth/AuditDomainChip";
import AuditSignupSteps from "@/components/auth/AuditSignupSteps";

type AuditHandoffIntroProps = {
  auditUrl: string;
};

export default function AuditHandoffIntro({ auditUrl }: AuditHandoffIntroProps) {
  return (
    <div className="mb-8 space-y-6">
      <div className="text-center">
        <h1 id="login-heading" className="mb-3 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          Create an account to save your audit
        </h1>
        <p className="text-base leading-relaxed text-gray-600 sm:text-lg">
          We’ll map key pages and surface UX issues on your site.
        </p>
      </div>

      <AuditSignupSteps />
      <AuditDomainChip auditUrl={auditUrl} />
    </div>
  );
}
